import {
  Button,
  Grid,
  FormControlLabel,
  Switch,
  Box,
} from "@mui/material";
import React from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

const products = ["CRM", "Analytics", "Billing"];

export function AssignProducts({ isEdit , onNext, data, onChange, handleBlur, onSkip }) {
  const { tabId }:any = useParams();
  const [selected, setSelected] = React.useState([]);
  const values = {
    hasDashboardAccess : true,
    hasCMSAccess : true,
    hasCMSRCMStatusReportAccess : true,
    hasEstimatorAccess : true,
    hasPricerAccess : true,
    hasVendorManagementAccess : true,
  }
  // const submit = async () => {
  //   onNext();
  // };

  return (
    <Card className="mt-3">
      <Card.Header>
        <Grid container className="align-items-center">
          <Grid xs={10} item>
            <h5 className="mb-0">Products</h5>
          </Grid>
        </Grid>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-md-5">
            <FormControlLabel
              control={
                <Switch
                  name="hasDashboardAccess"
                  color="primary"
                  checked={data.hasDashboardAccess}
                  onChange={onChange}
                  onBlur={handleBlur}
                  value={data.hasDashboardAccess}
                />
              }
              label="Dashboards"
            />
          </div>
          <div className="col-md-5">
            <ul className="tree">
              <li style={{ paddingLeft: "12px" }}>
                <summary style={{
                  marginLeft: '-12px',
                  marginBottom: '-10px'
                }}><FormControlLabel
                    control={
                      <Switch
                        name="hasCMSAccess"
                        color="primary"
                        checked={data.hasCMSAccess}
                        onChange={onChange}
                        onBlur={handleBlur}
                        value={data.hasCMSAccess}
                      />
                    }
                    label="Contract Mangement"
                  /></summary>
                {values.hasCMSAccess && <ul style={{ position: "absolute" }}>
                  <li>
                    <details>
                      <summary style={{ marginLeft: "2px" }}><FormControlLabel style={{ marginTop: "-4px" }}
                        control={
                          <Switch
                            size="small"
                            name="hasCMSRCMStatusReportAccess"
                            color="primary"
                            checked={data.hasCMSRCMStatusReportAccess}
                            onChange={onChange}
                            onBlur={handleBlur}
                            value={data.hasCMSRCMStatusReportAccess}
                          />
                        }
                        label="RCM Status Report"
                      /></summary>
                    </details>
                  </li>
                </ul>}
              </li>
            </ul>



            {/* // } */}
          </div>
          <div className="col-md-5">
            <FormControlLabel
              control={
                <Switch
                  name="hasEstimatorAccess"
                  color="primary"
                  checked={data.hasEstimatorAccess}
                  onChange={onChange}
                  onBlur={handleBlur}
                  value={data.hasEstimatorAccess}
                />
              }
              label="Claim Estimation"
            />
          </div>
          <div className="col-md-5">
            <FormControlLabel
              control={
                <Switch
                  name="hasPricerAccess"
                  color="primary"
                  checked={data.hasPricerAccess}
                            onChange={onChange}
                            onBlur={handleBlur}
                            value={data.hasPricerAccess}
                />
              }
              label="Price Transparency"
            />
          </div>
          <div className="col-md-5">
            <FormControlLabel
              control={
                <Switch
                  name="hasVendorManagementAccess"
                  color="primary"
                  checked={data.hasVendorManagementAccess}
                  onChange={onChange}
                  onBlur={handleBlur}
                  value={data.hasVendorManagementAccess}
                />
              }
              label="Vendor Management"
            />
          </div>
        </div>
        <Box display="flex" justifyContent="center" mt={1.5}  columnGap={5}>
          <Button variant="contained" onClick={() => onNext(data)}>
            Save & Next
          </Button>
          {isEdit && !tabId &&
            <Button variant="contained" onClick={() => onSkip()}>
              Skip
            </Button>
          }
        </Box>
      </Card.Body>
    </Card>
  );
}
